import { Alert, Text } from '@nimbus-ds/components';
import useTranslationBilling from 'domains/Billing/useTranslationBilling';
import { PaymentStatusAlertFailed } from './components';
import { usePayment } from '../../hooks';
import { PaymentStatusAlertProps } from '../../PaymentStatusAlert';

function PaymentStatusAlertCreditCard({
  concept,
  externalReference,
  isExternalContext = false,
  chargeId,
  showPaymentButton = false,
}: PaymentStatusAlertProps) {
  const t = useTranslationBilling('checkout.paymentStatusAlert.creditCard');
  const paymentData = usePayment(concept, externalReference, chargeId);

  if (!paymentData) return null;
  const { payment, paymentStatus, isFromRecurrentPayment } = paymentData;

  switch (paymentStatus) {
    case 'IN_PROCESS':
      return (
        <Alert
          show={!isExternalContext}
          appearance="warning"
          title={t('inProgress.title')}
        >
          <Text>{t('inProgress.message')}</Text>
        </Alert>
      );
    case 'FAILED':
      return (
        <PaymentStatusAlertFailed
          payment={payment}
          isExternalContext={isExternalContext}
          isFromRecurrentPayment={!!isFromRecurrentPayment}
          showPaymentButton={showPaymentButton}
          concept={concept}
          externalReference={externalReference}
        />
      );
    default:
      return null;
  }
}

export default PaymentStatusAlertCreditCard;
